import React, { useEffect, useState } from 'react'
import axiosScoring from '../axios/axiosScoring';

export default function JudgeCard({ championId, horseId = "" }) {
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const BaseURL = process.env.REACT_APP_BASE_URL;
    const [isLoading, setisLoading] = useState(false);

    const [championshipResultData, setResult] = useState([]);

    async function getResults() {
        try {
            const res = await axiosScoring.get(`/shows/getchampionshipwithjudgesinsideresult?ChapiomshipId=${championId}${!!horseId ? ('&ChapiomshipHorseId=' + horseId) : ''}`);
            if (res?.status == 200) {
                if (res?.data?.responseCode == "200") {
                    setResult(res?.data)
                }
            }

        } catch (error) {

        }
    }

    useEffect(() => {
        getResults();

    }, [])

    const imgStyle= {
        maxWidth: 50,
    width: "100%",
    border: "1px solid rgb(221, 221, 221)",
    padding: 1,
    height: 30,}

    return (
        <>
            <div className="scrolableTable  mb-form-group" >
                <table
                    className="table table-striped table-bordered"
                    style={{
                        direction:
                            currentLanguage == "ar"
                                ? "rtl"
                                : "ltr",
                    }}
                >
                    <thead
                        className="fw-bold "
                        style={{
                            color: "white",
                        }}
                    >
                        <tr className='bgDarkGray text-center' style={{ background: '#000' }}>
                            {!!championshipResultData?.result?.headers &&
                                championshipResultData?.result?.headers.map(
                                    (item, i) => (
                                        <th
                                            className="text-center text-white "
                                            style={{ background: 'var(--gray)' }}
                                            key={i}
                                        >
                                            {item}
                                        </th>
                                    )
                                )}
                        </tr>
                    </thead>
                    <tbody>
                        {!!championshipResultData &&
                            !isLoading &&
                            !!championshipResultData?.result?.results &&
                            championshipResultData?.result?.results.map(
                                (item, i) => (
                                    <tr key={i} className='text-center'>
                                        {!!item &&
                                            item.rowData.map(
                                                (ele, ind) => (
                                                    <td key={ind}>{ele}</td>
                                                )
                                            )}
                                    </tr>
                                )
                            )}
                    </tbody>
                </table>
            </div>
            <div className="w-100 row">
                {championshipResultData?.result?.judges?.map((judge, index) => (
                    <div key={index} className="col-md-3 mb-3">
                        <div className="flagJudgDiv">
                            <span>{judge?.letter}</span>
                            <img
                            className='ms-2'
                                style={imgStyle}
                                src={judge?.countryFlag}
                                alt={judge?.countryName}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `${BaseURL}/img/whiteFlag.png`;
                                    e.target.style.display = 'none';
                                }}
                            />
                            <span
                                style={{
                                    marginLeft: 8,
                                }}
                            >
                                {judge?.name}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}
